import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

/**
 * j'essaie ici de simululé un composant que va agir comme un session dans nos projet php
 * verifie la presence de la variable client si elle on verifie si la le token est toujours valable
 * 
 *
 * @param {string} redirectTo - le composant ou il faut rediriger en cas d'absence
 */

const SessionClient = ({redirectTo}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const raw = sessionStorage.getItem("client");
    const MySwal = withReactContent(Swal);
    if (raw) {//s'il y'a client dans le local storage on rediriger vers la page de menu
        try {
            
            const data = JSON.parse(raw);
            const token = data.access_token;
            const decoded = jwtDecode(token);
            console.log("exp: " + decoded.exp);
            console.log("date: " + Date.now());
            const isExpired = decoded.exp * 1000 < Date.now();
            if(isExpired){
                console.log("Le token est expiré.");
                sessionStorage.removeItem("client");
                localStorage.removeItem("total");
                localStorage.removeItem("restaurant");
                localStorage.removeItem("quantite");
                MySwal.fire({
                    icon: "success",
                    // title: "Delai d'attente depassé",
                    text: "Bien vouloir renouveller votre commande",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast", 
                    }
                });
                navigate(redirectTo);
            }
        } catch (e) {
            console.error("Erreur structure du json problematique", e);
            navigate(redirectTo);
        }
    }
    return;
  }, [navigate, redirectTo]);

  return null; // Ce composant ne rend rien
};

SessionClient.propTypes = {
  redirectTo: PropTypes.string,
};

export default SessionClient;